// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"playerPill__gradient-bg5__KFNYz","pillContainer":"playerPill__pillContainer__Zu4YQ","name":"playerPill__name__Z3W3g","closeButton":"playerPill__closeButton__vordl"};